// import React from 'react'

// const SingleAgent = () => {
//   return (
//     <div>SingleAgent</div>
//   )
// }

// export default SingleAgent

import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import "../../dashboard.scss";
import Accordion from "react-bootstrap/Accordion";
import { Navigate, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import WholeLoader from "../../WholeLoader";
import SingleAgentRight from "./comp/SingleAgentRight";
import "./SingleAgent.scss";
// import CreateAgent from "./DashboardComponents/Agents/createAgent";
// import WelcomeScreen from "./DashboardComponents/welcomeScreen";
// import KnowledgeBasis from "./DashboardComponents/KnowledgeBasis/KnowledgeBasis";
// import Dialer from "./DashboardComponents/Dialer/Dialer";
// import Setting from "./DashboardComponents/Setting/Setting";
// import OwnAgents from "./DashboardComponents/OwnAgents/ownAgents";
// import OldDialer from "./DashboardComponents/Dialer/OldDialer";
// import WholeLoader from "./WholeLoader";
// import NewDialer from "./DashboardComponents/Dialer/NewDialer";
import axios from "axios";
import AgentSettings from "./comp/settings/AgentSettings";
import Setting from "../Setting/Setting";

const SingleAgent = () => {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);

  var data = localStorage.getItem("phone");
  console.log("data", data);
  if (data !== undefined && data !== null && data != "undefined") {
    console.log("here");
    var phone = JSON.parse(data);
  }

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    }

    getProfile();
  }, []);

  const getProfile = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/customer/profile`;
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      axios
        .get(apiUrl, config)
        .then((response) => {
          console.log("profile data", response.data);

          localStorage.setItem("phone", JSON.stringify(response?.data?.phone));
          localStorage.setItem("name", JSON.stringify(response?.data?.userName));
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowLoader(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  const [isActive, setIsActive] = useState("tab1");
  const toggleSidebar = () => {
    setIsActive(!isActive);
  };
  const [activeTab, setActiveTab] = useState("tab1");
  const [mobileWidth, setMobileWidth] = useState(0);
  //console.log("the tab is:", activeTab);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const [isVisible, setIsVisible] = useState(true);
  const handleDrawer = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsVisible(mobileWidth && mobileWidth >= 1200);
  }, [mobileWidth]);

  const [openAccordion, setOpenAccordion] = useState(null);
  const toggleAccordion = (eventKey) => {
    if (openAccordion === eventKey) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(eventKey);
    }
  };

  const isAccordionOpen = (eventKey) => {
    return openAccordion === eventKey;
  };
  if (activeTab === "tab32") {
    Navigate("/goal");
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebarLeft = (event) => {
    event.stopPropagation();
    setIsSidebarOpen((prev) => !prev);
  };

  /* SideBar Closed Click start */
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  /* SideBar Closed Click End */

  return phone ? (
    <>
      {/* <div className="dashboardWrapper"> */}
      {/* <div className="dashboard-left-content"> */}
      <section className="dashboard">
        <Icon icon="iconamoon:menu-burger-horizontal" className="burger-Icon" onClick={(event) => toggleSidebarLeft(event)} />
        {/* <div className="dashboard-left-content"{`sidebar ${isSidebarOpen ? 'open' : ''}`}> */}
        <div className={`dashboard-left-content sidebar ${isSidebarOpen ? "open" : ""}`} ref={dropdownRef}>
          <ul>
            <p className="tools">Tools</p>
            <div
              className={`dashboardLink ${activeTab === "tab1" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab1");
                toggleSidebar();
              }}
            >
              <Icon className="iconsdash" icon="material-symbols:database-outline" color="white" width="32" height="32" />
              <li
                onClick={() => {
                  // handleTabChange("tab1");
                  // toggleSidebar();
                }}
              >
                Profile
              </li>
            </div>
          </ul>

          <div
            className={`settingDiv`}
            onClick={(event) => {
              toggleSidebarLeft(event);
              handleTabChange("tab2");
              toggleSidebar();
            }}
          >
            <div
              className={`settingContent ${activeTab === "tab2" ? "active" : ""}`}
              onClick={() => {
                // handleTabChange("tab6");
                // toggleSidebar();
              }}
            >
              <Icon className="settingImg" icon="solar:settings-linear" color="white" width="32" height="32" />
              <p className="settingText">Settings</p>
            </div>
          </div>
        </div>

        <div className={`right singleAgent-right ${!isSidebarOpen ? "open" : ""}`}>
          {activeTab === "tab1" && <SingleAgentRight />}
          {activeTab === "tab2" && <AgentSettings childern={<Setting />} />}
        </div>
      </section>
      {showLoader && <WholeLoader />}
    </>
  ) : (
    <></>
  );
};

export default SingleAgent;
